import React from 'react';

import { Box, Card } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { InputSearch } from 'common/components';

const Filters = ({ filterData, handleChange }) => {
    return (
        <Card>
            <Card.Body>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                    <InputSearch
                        id="input-search"
                        onChange={(e) =>
                            handleChange('searchText', e.target.value, true)
                        }
                        value={filterData?.searchText}
                    />
                </Box>
            </Card.Body>
        </Card>
    );
};

Filters.propTypes = {
    filterData: PropTypes.object,
    handleChange: PropTypes.func,
};

export default Filters;
